<template>
  <div class="form-group">
    <div class="input-group">
      <label for="periodo">Periodo</label>
      <select @change="handlePeriodo" class="pointer" v-model="periodo" name="periodo" id="periodo">
        <option value="">Seleccione Periodo...</option>
        <option v-for="item in periodos" :value="item">{{item.periodo_inicial}} - {{item.periodo_final}}</option>
      </select>
      <i class="bar"></i>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import makeQuery from "../../../api/helper";

  export default {
    name: "selectPeriodo",
    created() {
      this.$store.dispatch("consolidadoPeriodo/getPeriodos")
    },
    computed: {
      ...mapGetters({
        periodos: "consolidadoPeriodo/periodos",
      })
    },
    methods: {
      handlePeriodo() {
        const query = this.createQuery()
        this.$emit("sendFiltros", query)
      },
      createQuery() {
        return makeQuery({
          filtros: [
            {field: 'anioAnterior', value: this.periodo.periodo_inicial, operator: '='},
            {field: 'anio', value: this.periodo.periodo_final, operator: '='},
          ]
        })
      }
    },
    data() {
      return {
        periodo: ""
      }
    },
  }
</script>

<style scoped>

</style>
